module.exports = __webpack_public_path__ + "static/img/empty-data.6c0a3087.png";